import axios from 'axios';
import { Link } from 'react-router-dom';
import { BiInfoCircle } from 'react-icons/bi';
import React, { useState, useEffect } from 'react';
import { Box, Button, Divider, Grid, GridItem, Text } from '@chakra-ui/react';

import ReactHelmet from '../../../../components/ReactHelmet';

const data = [
  {
    title: 'Privacy Statement',
    link: '/About/privacy',
  },
  {
    title: 'Terms of Use',
    link: '/About/terms',
  },
  {
    title: 'Contact Us',
    link: '/About/contactUs',
  },
  {
    title: 'Send Message',
    link: '/About/message',
  },
];

const CorporateMenu = () => {
  const [websiteSettings, setWebsiteSettings] = useState([]);

  useEffect(() => {
    const getWebsiteData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/website-settings`
        );

        setWebsiteSettings(response?.data?.data);
      } catch (error) {
        console.log(error);
      }
    };

    getWebsiteData();
  }, []);
  return (
    <>
      <ReactHelmet title={'Corporate Information | Bank Enterprise'} />

      <Box
        h={'auto'}
        display={'flex'}
        flexDir={'column'}
        justifyContent={'center'}
        boxShadow={'3px 3px 200px #000 inset'}
        padding={['10px 0', '10px 0', '2rem 0', '2rem 0', '2rem 0']}
        w={[
          '100%',
          '100%',
          'calc(100% - 200px)',
          'calc(100% - 304px)',
          'calc(100% - 304px)',
        ]}
        background={
          websiteSettings?.background_images?.other_page_bg_type === 'color'
            ? websiteSettings?.background_images?.other_page_bg_value
            : `url('${websiteSettings?.background_images?.other_page_bg_value}')`
        }
        backgroundSize={'cover'}
        backgroundRepeat={'no-repeat'}
      >
        <Box
          display={'flex'}
          flexDir={'row'}
          justifyContent={'center'}
          w={'100%'}
        >
          <Box display={'flex'} flexDir={'column'} w={'100%'}>
            <Box
              w={'100%'}
              flexDir={'row'}
              display={'flex'}
              alignItems={'center'}
              alignContent={'center'}
              justifyContent={'center'}
            >
              <Text
                width={'100%'}
                color={'black'}
                fontFamily={'Poppins'}
                fontSize={[18, 18, 18, 20, 25]}
                flex={[
                  '0 0 7rem',
                  '0 0 7rem',
                  '0 0 7rem',
                  '0 0 7rem',
                  '0 0 9rem',
                ]}
              >
                Corporate Information
              </Text>
              <Divider
                ml={4}
                w={'45%'}
                borderWidth={3}
                borderRadius={5}
                borderColor={'#E76D0C'}
                orientation={'horizontal'}
              />
            </Box>
            <Box
              my={5}
              w={'100%'}
              display={'flex'}
              padding={'0 1rem'}
              justifyContent={'center'}
            >
              <Grid
                templateColumns={[
                  'repeat(1, 1fr)',
                  'repeat(1, 1fr)',
                  'repeat(2, 1fr)',
                  'repeat(2, 1fr)',
                  'repeat(2, 1fr)',
                ]}
                gap={5}
              >
                {data.map((item) => {
                  return (
                    <GridItem w='100%'>
                      <Link to={item.link}>
                        <Button
                          m={0}
                          p={10}
                          gap={2}
                          w={'100%'}
                          flexDir={'row'}
                          display={'flex'}
                          color={'#E76D0C'}
                          alignItems={'center'}
                          justifyContent={'flex-start'}
                          _hover={{
                            backgroundColor: '#E76D0c',
                            transitionDelay: '1s ease-in',
                            color: 'white',
                          }}
                        >
                          <BiInfoCircle size={28} />
                          <Text
                            fontFamily={'Poppins-Bold'}
                            fontSize={[18, 18, 22, 22, 25]}
                          >
                            {item.title}
                          </Text>
                        </Button>
                      </Link>
                    </GridItem>
                  );
                })}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CorporateMenu;
